import * as React from 'react'
import moment from 'moment-timezone'
import 'moment-timezone/builds/moment-timezone-with-data'
import 'moment/locale/fr'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { Controller, useFormContext } from 'react-hook-form'
import { TextField } from '@material-ui/core'
import { TIMEZONE } from '../../../../config'

export default function DateTimePickerWithTimezone({
  source,
  label,
  ...props
}) {
  const { setValue, getValues, ...form } = useFormContext()

  const convertToUserTimezone = (utcValue) => {
    return utcValue ? moment(utcValue).tz(TIMEZONE) : null
  }

  const convertToUTC = (date) => {
    // Extract date and time components
    const year = date.year()
    const month = date.month()
    const day = date.date()
    const hour = date.hour()
    const minute = date.minute()
    const second = date.second()
    // Construct a new moment object in Paris timezone and set the extracted components
    const parisDate = moment
      .tz(TIMEZONE)
      .year(year)
      .month(month)
      .date(day)
      .hour(hour)
      .minute(minute)
      .second(second)
    return parisDate ? parisDate.utc() : null
  }

  const initialValue = React.useMemo(() => {
    const sourceValue = getValues(source)
    return convertToUserTimezone(sourceValue)
  }, [getValues, source])

  return (
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      dateLibInstance={moment}
      adapterLocale="fr"
    >
      <Controller
        name={source}
        control={form.control}
        render={({ field }) => (
          <DateTimePicker
            {...field}
            label={label}
            value={initialValue}
            onChange={(date) =>
              setValue(source, convertToUTC(date), { shouldDirty: true })
            }
            renderInput={(params) => <TextField {...params} />}
            {...props}
          />
        )}
      />
    </LocalizationProvider>
  )
}
